export const DISABLE_ACCESS_RIGHTS = 'Disable Permissions';
export const ENABLE_ACCESS_RIGHTS = 'Enable Permissions';
